<div class="modal-header">
	<h4 class="modal-title">
		<span jhiTranslate="ontology-manager.variable.formula.add.title"></span>&nbsp;
		<jhi-help-link [helpKey]="HELP_MANAGE_ONTOLOGIES_FORMULAS"></jhi-help-link>
	</h4>
	<button type="button" class="btn-close" aria-label="Close" (click)="discard()"></button>
</div>
<div class="modal-body">
	<form #f="ngForm" (ngSubmit)="save()" novalidate>
		<div *ngIf="showWarningEditableMessage" class="alert alert-warning" role="alert">
			<span jhiTranslate="ontology-manager.variable.formula.used.in.a.study"></span>
		</div>
		<!-- Target Variable (read-only display) -->
		<div class="mb-3 row">
			<label class="col-sm-3 col-form-label fw-bold" jhiTranslate="ontology-manager.variable.formula.target.variable"></label>
			<div class="col-sm-9">
				<p class="form-control-plaintext mb-0">
					<truncate-span [textInput]="variable?.name"></truncate-span>
				</p>
			</div>
		</div>
		<!-- Input Variables -->
		<div class="mb-3 row">
			<label class="col-sm-3 col-form-label fw-bold" jhiTranslate="ontology-manager.variable.formula.input.variables">Input Variables</label>
			<div class="col-sm-9">
				<jhi-input-variable
					[selectionType]="'single'"
					[variableTypeIds]="[1808, 1802, 1806]"
					(variableSelect)="onAddInputVariable($event)">
				</jhi-input-variable>
			</div>
		</div>
		<!-- Calculation -->
		<div class="mb-3 row">
			<label class="col-sm-3 col-form-label fw-bold label-required" jhiTranslate="ontology-manager.variable.formula.calculation"></label>
			<div class="col-sm-9">
				<jhi-formula-editor
					name="definition"
					[(ngModel)]="formula.definition"
					(ngModelChange)="onDefinitionChanged($event)"
					[maxLength]="DEFINITION_TEXT_LIMIT"
					[disabled]="isLoading"
					[required]="true"
					#definition="ngModel">
				</jhi-formula-editor>
				@if ((f.submitted || definition.touched) && definition.errors?.required) {
					<div class="text-danger pt-2">{{ 'ontology-manager.variable.validation.formula.calculation.required' | translate }}</div>
				}
			</div>
		</div>
	</form>
</div>
<div class="modal-footer">
	<button class="btn btn-secondary" type="button" (click)="discard()" [disabled]="isLoading">
		<span jhiTranslate="discard"></span>
	</button>

	<button class="btn btn-primary" type="button" (click)="save()" [disabled]="isLoading || f.invalid">
		<span *ngIf="isLoading" class="throbber throbber-btn"></span>
		<span class="fa fa-save"></span>&nbsp;
		@if (modeView === ModeView.EDIT) {
			<span jhiTranslate="update"></span>
		} @else {
			<span jhiTranslate="create"></span>
		}
	</button>
</div>
